import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilderService } from '~/app/core/services/form-builder.service';
import { FormBuilderBase } from '../../../core/models/form-builder/form-builder-base';

@Component({
  selector: 'app-dynamic-form-builder',
  templateUrl: './dynamic-form-builder.component.html',
  styleUrls: ['./dynamic-form-builder.component.scss']
})
export class DynamicFormBuilderComponent implements OnInit {

  @Input() configs: FormBuilderBase<string>[] = [];
  form: FormGroup;
  payLoad = '';

  constructor(private formBuilderService: FormBuilderService) { }

  ngOnInit(): void {
    if (this.configs) {
      this.formBuilderService.form = this.form = this.formBuilderService.toFormGroup(this.configs);
    }
  }

}
